import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 创建 store 实例
const store = new Vuex.Store({
	 //操作数据的,类似于Vue的data
	state: {
		
	},
	mutations: { //操作业务逻辑的，类似于Vue的methods
		
	},
	getters: { //对外提供数据，不负责 修改数据，如果想要修改 state 中的数据，请 去找 mutations
		
	}
});

export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js